var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inbox-menu-wrapper" },
    _vm._l(_vm.processedData, function (item) {
      return _c(
        "div",
        {
          key: item.submissionId,
          class: [
            "menu-item",
            { selected: item.submissionId === _vm.selectedSubmissionId },
          ],
          attrs: { "data-submission-id": item.submissionId },
          on: {
            click: function ($event) {
              return _vm.selectItem(item)
            },
          },
        },
        [
          _c("div", { staticClass: "menu-item-content" }, [
            _c("div", { staticClass: "menu-item-header" }, [
              _c("span", { staticClass: "submission-number" }, [
                _vm._v("#" + _vm._s(item.submissionNo)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "time-ago" }, [
                _vm._v(_vm._s(_vm.formatDateRelative(item.updatedAt))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "menu-item-text" }, [
              _vm._v(
                "\n                " + _vm._s(item.menuText) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "menu-item-date" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.formatDate(item.updatedAt)) +
                  "\n            "
              ),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }